import * as Sentry from '@sentry/browser';

const SERVERLESS_API = process.env.GATSBY_SERVERLESS_API || '';

const AWS_MAX_FILE_SIZE_IN_BYTES = 4e6;

export const submitFormData = async (formType, formData) => {
  try {
    const result = await fetch(`${SERVERLESS_API}/forms-endpoint`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({
        form_type: formType,
        formData: {
          ...formData,
        },
      }),
    });
    const json = await result.json();
    return { status: result.status, message: json.msg, emailData: json.emailData };
  } catch (err) {
    Sentry.captureException(err);
    console.error(err);
  }
};

export function getBase64(file) {
  // $FlowFixMe
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function validateInputType(mimeType) {
  switch (mimeType) {
    case 'application/pdf':
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.apple.pages':
    case 'application/vnd.apple.numbers':
    case 'image/jpeg':
    case 'image/tiff':
    case 'image/bmp':
    case 'image/png':
    case 'text/plain':
    case 'text/csv':
    case 'text/rtf':
    case 'application/vnd.oasis.opendocument.text':
    case 'application/vnd.oasis.opendocument.spreadsheet':
      return true;
    default:
      return false;
  }
}

export function validateInputSize(sizeInBytes, maxSizeInMb) {
  const maxSizeInBytes = maxSizeInMb * 1e6;
  return sizeInBytes <= maxSizeInBytes;
}

function chunkFileContent(content, size) {
  const numChunks = Math.ceil(content.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0; i < numChunks; i++) {
    chunks[i] = content.substring(i * size, i * size + size);
  }

  return chunks;
}

async function requestForPresignedUrl() {
  const result = await fetch(`${SERVERLESS_API}/forms-endpoint`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify({
      form_type: 'fileUpload',
    }),
  });
  const response = await result.json();

  return response;
}

async function uploadFileToS3(url, file) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      "Content-Length": new Blob([file.content]).size
    },
    body: file.content,
  });
}

export async function handleLargeFilesIfRequired(files) {
  const totalSize = Object.values(files).reduce((acc, file) => acc + (file.content?.length || 0), 0);

  if (totalSize > AWS_MAX_FILE_SIZE_IN_BYTES) {
    return (await Promise.all(Object.values(files).map(async (file) => {
      const { id, url } = await requestForPresignedUrl();

      await uploadFileToS3(url, file);

      file.content = id;
      file.type = 'id';

      return file;
    }))).reduce((acc, file, index) => {
      acc[`attachment${index + 1}`] = file;

      return acc;
    }, {});
  }

  return files;
}
